export const CREDITS_CALLS = {
  'credits-and-free-days': {
    use_mock: false,
    mock_endpoint: 'users/credits_and_free_days',
    api_type: 'GET',
    requires_auth: true,
  },
}